import { Component } from '@angular/core';
import { NotificationDto, NotificationModel, NotificationType } from '@sestek/notification';
import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { ConversationService } from 'src/app/insights/proxy/conversation.service';
import { FileDownloadHelperService } from 'src/app/shared/services/file-download-helper.service';
import { DateFormatterPipe } from 'src/app/shared/pipes/date-formatter.pipe';
import { DateDisplayType } from 'src/app/shared/enums/date-display-type';
import { ConversationExportedNotificationModel } from '../models/conversation-exported-notification-model';

@Component({
  selector: 'cai-conversation-exported-notification',
  templateUrl: './conversation-exported-notification.component.html',
  styleUrls: ['./conversation-exported-notification.component.scss'],
  standalone: false,
})
@NotificationType('ConversationExportedNotification')
export class ConversationExportedNotificationComponent {
  _data: NotificationDto;

  get data() {
    return this._data;
  }
  set data(data: NotificationDto) {
    this._data = data;
    this.notification = JSON.parse(data.payload);
  }

  notification: ConversationExportedNotificationModel;

  constructor(
    private conversationService: ConversationService,
    private localizationService: LocalizationService,
    private toasterService: ToasterService,
    private fileDownloadHelperService: FileDownloadHelperService,
    private dateFormatterPipe: DateFormatterPipe,
  ) {}

  showNotification(notification: NotificationModel) {
    this.notification = JSON.parse(notification.payload);

    const message = this.localizationService.instant('Conversation::ReportIsReady');

    this.toasterService.success(message);
  }

  downloadFile() {
    let nowString = this.dateFormatterPipe.transform(
      new Date(),
      DateDisplayType.shortDateShortTime,
    );

    nowString = nowString.replace(/[^a-zA-Z0-9]/g, '_');

    const fileName = `${this.localizationService.instant(
      'Conversation::ReportFileNamePrefix',
    )}_${nowString}`;

    this.conversationService.getConversationReport(this.notification.fileId).subscribe(
      (result) => {
        this.fileDownloadHelperService.handleDownloadFileResult(result, fileName);
      },
      (error) => {
        this.fileDownloadHelperService.handleDownloadFileError(error);
      },
    );
  }
}
